import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, switchMap } from 'rxjs';

// NavNode from '@neutrino/core/app-shell/nav/nav-node' is inaccessible;
// https://gitlab-van.corp.fortinet.com/neutrino/neutrino/-/issues/349
interface NavNode {
    label?: string;
}

/**
 * Publishes the 'clickedSection' observable from the NavComponent attached to the app shell.
 * This lets any component or service observe these changes
 */
@Injectable()
export class NavSectionService {
    setClickedSectionObservable(o: Observable<NavNode | undefined>) {
        this.clickedSectionObservableSubject.next(o);
    }
    private clickedSectionObservableSubject = new BehaviorSubject<Observable<NavNode | undefined>>(
        of(undefined)
    );
    clickedSection = this.clickedSectionObservableSubject.pipe(
        switchMap(nodeSubject => nodeSubject)
    );
}
